var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartOutline = function SvgHeartOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7.602 5.509c-1.108-.076-2.096.34-2.828 1.03h-.001c-1.5 1.409-1.827 3.768-.138 5.373l7.37 6.321 7.38-6.328c1.663-1.589 1.339-3.944-.158-5.358-.732-.69-1.717-1.108-2.822-1.035-.994.068-2.152.536-3.366 1.69a1.5 1.5 0 0 1-2.183-.122m-.006-.007.001.002.002.002.003.003q0 .001 0 0l-.028-.03a5.162 5.162 0 0 0-.8-.677 4.9 4.9 0 0 0-2.426-.864m8.702-1.493c1.565-.105 2.95.493 3.953 1.44 1.976 1.867 2.59 5.236.146 7.55l-.022.021-7.95 6.818a.65.65 0 0 1-.425.155.65.65 0 0 1-.425-.155l-7.95-6.818-.022-.02c-2.458-2.328-1.847-5.697.136-7.561 1.006-.947 2.394-1.541 3.96-1.433 2.064.141 3.474 1.282 4.032 1.822.177.17.268.281.268.281q.526-.5 1.06-.875c1.083-.764 2.18-1.154 3.24-1.225",
    clipRule: "evenodd"
  })));
};
export default SvgHeartOutline;